import React, { FC } from 'react'
import Button from '@material-ui/core/Button'
import LoaderSmall from 'uiKit/loaders/loaderSmall'

import { BaseButtonWrap } from './BaseButton.style'

interface BaseButtonProps {
  disabled?: boolean
  loading?: boolean
  title: string
  color?: 'primary' | 'secondary' | 'default'
  onClick: () => void
  styles?: React.CSSProperties
}

export const BaseButton: FC<BaseButtonProps> = ({ disabled, loading, title, onClick, color, styles }): JSX.Element => {
  return (
    <BaseButtonWrap style={styles}>
      {loading ? (
        <LoaderSmall showLoader />
      ) : (
        <Button disabled={disabled} color={color || 'default'} onClick={onClick} style={styles}>
          {title}
        </Button>
      )}
    </BaseButtonWrap>
  )
}
